import Application from './Application';

export default Application;
